module.exports = __webpack_public_path__ + "assets/img/title-8f8edc3f.png";